var _excluded = ["source", "clusterThreshold"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Cluster from 'ol/source/Cluster';
import Point from 'ol/geom/Point';
import { getCenter } from 'ol/extent';
import { VectorLayer } from '../VectorLayer';
import { getCachedOrCreate } from '../util';

/**
 * Internal implementation of ClusterSource. Can be used with custom
 * VectorSource implementations.
 *
 * See ClusterSource for ready to use component.
 *
 * @component
 */
export function ClusterSourceImpl(_ref) {
  var source = _ref.source,
    _ref$clusterThreshold = _ref.clusterThreshold,
    clusterThreshold = _ref$clusterThreshold === void 0 ? 50 : _ref$clusterThreshold,
    vectorProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var map = vectorProps.map,
    layerName = vectorProps.layerName;
  var cachedSource = getCachedOrCreate(map, '_clusterSources', layerName, function () {
    return new Cluster({
      distance: clusterThreshold,
      source: source,
      geometryFunction: function geometryFunction(feature) {
        var extent = feature.getGeometry().getExtent();
        var center = getCenter(extent);
        return new Point(center);
      }
    });
  });
  return /*#__PURE__*/React.createElement(VectorLayer, _extends({
    source: cachedSource
  }, vectorProps));
}
ClusterSourceImpl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Source to be clustered.
   */
  source: PropTypes.any,
  /**
   * Cluster threshold.
   */
  clusterThreshold: PropTypes.number
} : {};
export default ClusterSourceImpl;